import Taskbar from './taskbar.js';
import logo from '../images/txedlif-logo1.png';
import tea from '../images/TEA_logo_gray.png';
import '../styles/header.css';
                
const Header = () => {
    return (
        <header className="header__container">

            {/* Top gray bar */}
            <div className="header__topbar">
                <div className="header__links">
                    <a href="https://tea.texas.gov" target="_blank" rel="noopener noreferrer">
                        <img src={tea} className="header__link" alt="TEA logo" />
                    </a>
                    <a className="header__link" href="https://tea.texas.gov" target="_blank" rel="noopener noreferrer">
                        TEA Website
                    </a>
                    <a className="header__link" href="https://tea.texas.gov/about-tea/contact-us" target="_blank" rel="noopener noreferrer">
                        Contact TEA
                    </a>
                    <a className="header__link" href="https://public.govdelivery.com/accounts/TXTEA/subscriber/new" target="_blank" rel="noopener noreferrer">
                        Sign Up for Updates
                    </a>
                </div>
            </div>

            <div className="header__title">
                <div className="header__logo">
                    <img src={logo} className="header__image" alt="logo" />
                </div>
                <div className="header__text">
                    <h1>Biliteracy Mapping</h1>
                </div>
            </div>

            <Taskbar />

        </header>
    );
};
export default Header;
